module.exports = __webpack_public_path__ + "static/img/face2.c0d9c94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/face2.png
// module id = lj3V
// module chunks = 1